import styled from "styled-components";
import { Button as BaseButton } from "../../button/button";

export const Wrapper = styled.div`
  justify-content: center;
  display: flex;
  margin-top: 1rem;
  margin-bottom: -2rem;
`;

export const ButtonContinune = styled(BaseButton)`
  border-radius: ${({ theme }) => theme.sizes.radius.md};
  background: ${({ theme }) => theme.palette.gray[900]};
  color: #fff;
  display: flex;
  width: 120px;
  height: 35px;
  font-size: 1rem;
  font-weight: bold;
  align-items: center;
  justify-content: center;
  gap: 5px;
`;
